import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 8H20M10.5 16H20M4 13L7 16L4 19" vectorEffect="non-scaling-stroke" />
	</SVG>
);
